import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface OperacionTipoIva {
  id: number;
  denominacion: string;
  porcentaje: number;
  coeficiente: number;
  codigoAfip: number;
}

export interface OperacionesTipoIva {
  operacionesTipoIva: OperacionTipoIva[];
}

export interface ObtenerListadoOperacionTipoIvaResponse extends ResponseMessageWithInternalStatus {
  operacionTipoIva: {
    id: number;
    denominacion: string;
    porcentaje: number;
    coeficiente: number;
    codigoAfip: number;
  }[];
}

export interface OperacionesTipoIvaState {
  operacionesTipoIva: OperacionTipoIva[];
  error: boolean;
  debugMessage?:any
}

export const initialOperacionesTipoIvaState: OperacionesTipoIvaState = {
  operacionesTipoIva: [],
  error: false,
  debugMessage: null
};